import asFullScreen from '../components/as_full_screen';
import Navbar       from '../components/navbar';
import React        from 'react';
import rollbar      from '../rollbar';
import xhr          from 'xhr';


class KioskModePolicy extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    xhr.get('legal/privacy.html', (error, response, body) => {
      if (error)
        rollbar.error(error);
      if (response && response.statusCode === 200)
        this.setState({ html: body });
    });
  }

  render() {
    const { html } = this.state;

    return (
      <React.Fragment>
        <Navbar title="Privacy Policy"/>
        <div className="page-content">
          {html && (
            <div className="block tablet-inset" dangerouslySetInnerHTML={{ __html: html }}/>
          )}
        </div>
      </React.Fragment>
    );
  }
}


export default asFullScreen(KioskModePolicy);
